<!-- // TODO: Lista de chats recibe data de Barra de status de WhatsAap -->
<span *ngIf="!idSuscription" class="custom-font">{{ 'CHAT_LIST_SELECT' | translate}}</span>
<span 
*ngIf="data !== undefined && idSuscription" class="ovf" style="margin-top: 0;">
    <div *ngIf="!data">No hay resultados para {{ searchTerm }}</div>
    <ng-container *ngFor="let d of data; index as i" style="margin-top: 0;">
        <div class="listChat" (click)="chatClicked(d)" id="conversacion{{ i }}"
            [ngClass]="{'new-conversation': d.newConversation === true , 'message-count':d.countMessages != null && d.countMessages > 0}">
            <div class="p-grid">
                <div class="p-col-2" style="display: flex; margin-top: 20px;">
                    <div>
                        <img [src]="d.imageurl ? d.imageurl : 'https://img.icons8.com/bubbles/100/000000/user.png'"

                            [alt]="d.chatId" width="35" height="35" class="p-shadow-4 br50" />
                        
                    </div>
                </div>
                <div class="p-col-8">
                    <h5 style="margin-bottom: 10px;" class="uNameCustom" [innerHTML]="highlightSearchTerm(d.name ? d.name : d.chatId, searchTerm)">
                    </h5>
                    <div class="uMsg" [ngClass]="{'font-color-new': d.newConversation}"
                        [innerHTML]="highlightSearchTerm(d.text ? d.text : d.lastMessage !== ''? d.lastMessage : generateIconAndText(d), searchTerm)">

                        <span *ngIf="d.lastMessageFrom==='usuario'" class="mt-4">
                            <span *ngIf="d.lastMessageStatus==='leido'">
                                <img src="https://img.icons8.com/color/48/000000/double-tick.png" width="13" />
                            </span>
                            <span *ngIf="d.lastMessageStatus==='entregado'">
                                <img src="https://img.icons8.com/ios-glyphs/30/000000/double-tick--v1.png" width="13" />
                            </span>
                            <span *ngIf="d.lastMessageStatus==='enviado'">
                                <img src="https://img.icons8.com/material-outlined/24/000000/checkmark--v1.png"
                                    width="13" />
                            </span>
                        </span>
                    </div>
                </div>
                <div class="p-col-6 p-md-2 p-lg-2">
                    <h5 class="mDate">{{ d.dateTime ? formatDate(d.dateTime) : d.date }}</h5>

                    <div style="margin-top: 0;" *ngIf="d.countMessages != null && d.countMessages > 0" class="message-count-badge">{{ d.countMessages }}</div>
                </div>
            </div>
           
        </div>
    </ng-container>
</span>
